import { useApiClient } from '../../hooks/useApiClient.ts';
import { DisparityStage } from '../../types/Disparity/DisparityStage.type.ts';

export const useDisparityStageApi = () => {
  const apiClient = useApiClient();

  return {
    getDisparityStages: (): Promise<DisparityStage[]> => apiClient(`/disparity_stages/`),
  };
};
